//#region src/csatLimits.ts
var e = 2e3;
//#endregion
export { e as CSAT_COMMENT_MAX_LENGTH };
